var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.getProductCount())+" "+_vm._s(_vm.$t("role.orders.rounds.ddmi.details.table.products"))+", "+_vm._s(_vm.getProducertCount())+" "+_vm._s(_vm.$t("role.orders.tour.table.producers"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }